import { Component, OnInit, EventEmitter, Input, Output, QueryList, ViewChild, ViewChildren, Inject } from '@angular/core';
import { ProjectMasterService } from 'src/app/Service/projectmaster/projectmaster.service';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { ReportService } from 'src/app/Service/Report/Report.service';
import { CommonService } from 'src/app/Service/Common.service';
import { ChartComponent, LegendTitle, LegendLabelsContentArgs, SeriesLabels } from "@progress/kendo-angular-charts";
import { ISCurveOutputModel, ISCurveStatusCompletionPercentage } from 'src/app/ViewModel/Report.Model';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { Module } from "src/app/Service/element-details.data.service";
import { IProjectElementsOutput, IProjectElementDetailsOutput } from "src/app/ViewModel/ProjectElementsModel";
import { FieldConfig } from "src/app/CommonComponents/dynamic-form/interface/field.interface";
import { BehaviorSubject, forkJoin, Observable } from "rxjs";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { DynamicFormComponent } from "src/app/CommonComponents/dynamic-form/components/dynamic-form/dynamic-form.component";
import { LoaderService } from 'src/app/Service/Loader/loader.service';
import { formatDate } from '@angular/common';
import { ProjectViewModel } from 'src/app/ViewModel/ProjectModel';


@Component({
  selector: 'app-s-curve',
  templateUrl: './s-curve.component.html',
  styleUrls: ['./s-curve.component.css']
})
export class SCurveComponent implements OnInit {
  selectedOption: string = 'count';
  projectId!: number;
  memberId!: number;
  groupId!: number;
  //SCurveDetails: any[] = [];
  category: string[] = [];
  sCurveDetails: ISCurveOutputModel[] = [];
  panelOpenState = false;
  showFilterPanel = false;
  StatusCompletionPercentageDetails: ISCurveStatusCompletionPercentage[] = []
  projectElements: IProjectElementsOutput[] = [];
  elementsConfig: FieldConfig[] = [];
  numElements: Map<string, string> = new Map<string, string>();
  ProjectDetails: ProjectViewModel;
  projectStartDate: Date;
  projectEndDate: Date;
  TotalValue: string;
  ToDate: string;

  @ViewChild("docSetForm") dynamicForm: DynamicFormComponent;

  public seriesLabels: SeriesLabels = {
    visible: true, // Note that visible defaults to false
    padding: 1,
    font: "bold 12px Arial, sans-serif",
    position: "top",
  };
  Colors: string[] = ["#5DADE2", "#F7DC6F", "#F1948A"];

  constructor(private _projectService: ProjectMasterService, private _projInfoService: ProjectInfoService,
    private _commonService: CommonService, private _notificationService: NotificationService,
    private ReportService: ReportService, private loaderService: LoaderService,) { }

  async ngOnInit() {
    this.projectId = this._commonService.getProjectId();
    this.memberId = this._commonService.getLoggedInUserId();
    this.groupId = this._commonService.getLoggedInUserGroupId();

    this.ProjectDetails = this._commonService.getCurrentProjectDetails();
    if (this.ProjectDetails) {
      this.projectStartDate = new Date(this.ProjectDetails.startDate);
      this.projectEndDate = new Date(this.ProjectDetails.endDate);
      this.ToDate = this.ProjectDetails.endDate;
    }

    await this.getDynamicForm().then((res) => this.changeButtonToggle({ source: null, value: 'count' }));
  }

  changeButtonToggle(event: any) {
    this.selectedOption = event.value;
    this.LoadSCurve();
  }

  /**
     * Is Weightage Chart
     */
  get isWeightage(): boolean {
    return this.selectedOption === 'weightage';
  };

  collapseAllClick() {
    this.panelOpenState = !this.panelOpenState;

    if (this.panelOpenState) {
      this.showFilterPanel = false
      this.LoadStatusCompletionPercentage();
    }
  }

  toggleFilter() {
    this.showFilterPanel = !this.showFilterPanel;
    if (!this.showFilterPanel) {
      this.getDynamicForm();
      this.LoadSCurve();
      this.ToDate = null;
    }
  }

  async LoadSCurve() {
    this.LoadSearchDetails().then((res: any[]) => {
      let SCurveInput: any = {
        project_Id: this.projectId,
        group_Id: this.groupId,
        chart_Value: this.selectedOption,
        filterElementDetails: res,
        ToDate: this.ToDate
      }

      this.ReportService.GetSCurveDetails(SCurveInput).subscribe((res: any) => {
        if (res) {
          this.sCurveDetails = res;
          this.category = res[0].yAxizCategories;
          this.TotalValue = res[0].totalValue;
        }
      });
    })
  }

  async LoadSearchDetails(): Promise<any[]> {
    let resForm: FormGroup | undefined | null = this.dynamicForm.form;

    let FilterDetails: any[] = [];
    if (this.showFilterPanel) {
      this.projectElements.map(async x => {
        let result: any;
        let selectedValue: IProjectElementDetailsOutput = resForm.get(x.elementDescription)?.value;
        result = {
          dE_Id: x.elementId,
          dED_Id: selectedValue.dedId
        }
        FilterDetails.push(result);
      })
    }
    return FilterDetails;
  }


  getSelectedDate(selectedDate: any) {
    this.ToDate = selectedDate.value;
  }

  LoadStatusCompletionPercentage() {
    let StatusWiseCompletionPercentageInput: any = {
      project_Id: this.projectId,
      group_Id: this.groupId,
      tran_Type: 'GET_STATUS_WEIGHTAGE'
    }
    this.ReportService.GetStatusWiseCompletionPercentage(StatusWiseCompletionPercentageInput).subscribe((res: any) => {
      if (res) {
        this.StatusCompletionPercentageDetails = res;
      }
    });
  }

  UpdateStatusCompletionPercentage() {
    let CompletionPercentageInput = this.StatusCompletionPercentageDetails.reduce((a, b) => +a + +(b.completion_Percentage ? b.completion_Percentage : 0), 0);
    if (CompletionPercentageInput != 100) {
      this._notificationService.showToast("Sum of Completion Percentage should be equal to 100 !!!", "Warning");
      return
    }
    var seen = {};
    var hasDuplicates = this.StatusCompletionPercentageDetails.some(function (currentObject: any) {
      return seen.hasOwnProperty(currentObject.sequence)
        || (seen[currentObject.sequence] = false);
    });
    if (hasDuplicates) {
      this._notificationService.showToast("Sequence should be unique !!!", "Warning");
      return
    }

    let StatusWiseCompletionPercentageInput: any = {
      project_Id: this.projectId,
      group_Id: this.groupId,
      tran_Type: 'UPDATE_STATUS_WEIGHTAGE',
      statusWiseCompletionPercentageDetails: this.StatusCompletionPercentageDetails,
      actionBy: this._commonService.getLoggedInUserId(),
    }

    this.ReportService.UpdateStatusWiseCompletionPercentage(StatusWiseCompletionPercentageInput).subscribe((res: StandardOutputModel) => {
      if (res) {
        if (res.successCode == 200)
          this._notificationService.showPopup(res.successMessage, "Success").then(
            x => { this.panelOpenState = !this.panelOpenState; this.LoadSCurve(); }
          );
        else
          this._notificationService.showToast(res.successMessage, "Warning");

      }
    });
  }

  async getDynamicForm() {
    await this._projInfoService.getProjectElements({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.ScheduleDocument, IsQueryForStaticElement: false }).subscribe(
      (res: IProjectElementsOutput[]) => {
        this.projectElements = res;

        this.elementsConfig = res.filter(s => { return s.isMandatory == true }).map(x => {
          let field: FieldConfig;
          let childDEId = null;
          let childDEDescription = "";
          let data = res.filter(item => item.dependentElementId == x.elementId);

          if (data.length > 0) {
            childDEId = data[0].elementId;
            childDEDescription = data[0].elementDescription;
          }

          field = {
            de_id: x.elementId,
            module_id: Module.ScheduleDocument,
            dependent_de_id: x.dependentElementId,
            dependent_de_Description: x.dependentElementDescription,
            child_de_id: childDEId,
            child_de_Description: childDEDescription,
            name: x.elementDescription,
            deDescription: x.elementDescription,
            type: 'select',
            value: new BehaviorSubject(null)
          }

          return field;
        });
        this.dynamicForm.fields = this.elementsConfig;
        this.dynamicForm.createControl();
        this.onCascadingAutocomplete_Change();
        this.copyElementDetailsFromSource();
      });
  }

  onCascadingAutocomplete_Change() {
    this.elementsConfig.forEach((data: any) => {
      if (!!data.child_de_id) {
        this.dynamicForm.form.get(data.deDescription)?.valueChanges.subscribe(x => {
          let resForm: FormGroup = this.dynamicForm.value;
          let _field = this.dynamicForm.getCascadingAutocompleteDetails(data.child_de_Description);
          let parentControlSelectedValue: IProjectElementDetailsOutput = resForm.get(data.deDescription)?.value;

          if (_field.length > 0 && !!parentControlSelectedValue) {
            this._projInfoService.getProjectElementCascadingDetails({
              projectId: this.projectId,
              groupId: this.groupId,
              moduleId: Module.ScheduleDocument,
              deId: _field[0].de_id,
              deDescription: _field[0].deDescription,
              dependentDEId: _field[0].dependent_de_id,
              dependentDEDId: parentControlSelectedValue.dedId
            }).subscribe((res: IProjectElementDetailsOutput[]) => {
              if (res.length > 0) {
                res.map(val => val.displayText = (val.dedShortDescription!! && val.dedShortDescription.trim().length > 0 ? (val.dedShortDescription + " - ") : "") + val.dedDescription);
                _field[0].values = res;
              }
              else {
                _field[0].values = [];
              }
            }, err => { });
          }
          else {
            _field[0].values = [];
          }
        })
      }
    })
  }

  private copyElementDetailsFromSource() {
    let sourceProjElementForm: FormGroup = this.dynamicForm.value;
    this.projectElements.filter(s => { return s.isNumbering == false }).forEach(x => {
      let selectedValue: IProjectElementDetailsOutput = sourceProjElementForm.get(x.elementDescription)?.value;
      if (!!selectedValue) {
        let field: FieldConfig | undefined = this.elementsConfig.find(ele => ele.de_id == selectedValue.deId && ele.deDescription == selectedValue.deDescription);
        if (field && field.value) {
          field.value.next(selectedValue.dedId);
        }
      }
    })
  }

  public GetSCurveExportDetails() {
    this.LoadSearchDetails().then((res: any[]) => {
      this.loaderService.isLoading.next(true);
      let SCurveInput: any = {
        project_Id: this.projectId,
        group_Id: this.groupId,
        chart_Value: 'EXPORT_EXCEL',
        filterElementDetails: res
      }

      let fileName = "SCurve ScheduleDocument Details As Of " + formatDate(new Date(), 'dd-MMM-yyyy', 'en') + ".xlsx";
      this.ReportService.GetSCurveExportDetails(SCurveInput).subscribe((res: any) => {
        if (res) {
          this.loaderService.isLoading.next(false);
          const downloadLink = document.createElement("a");
          downloadLink.href = window.URL.createObjectURL(res);
          downloadLink.download = fileName;
          downloadLink.click();
          document.body.removeChild(downloadLink);
        }
      },
        err => {
          this.loaderService.isLoading.next(false);
          this._notificationService.showToast("Error in Downloading Report", "Warning");
        });
    })
  }
}
